import type { ILocationV2 } from '@sravni/types/lib/locations';

import { getCurrentUserLocation } from '../selectors/locations';

import { useAppSelector } from './redux';

export const useCurrentUserLocation = (): ILocationV2 => useAppSelector(getCurrentUserLocation);
